import React from 'react';

import Measure from 'react-measure';

import useLocation from 'hooks/location/use-location';
import { useAppHeaderDimensions } from 'hooks/use-app-header-dimensions';
import useMediaQuery from 'hooks/use-media-query';
import { useAuthContext } from 'state/auth';
import { useOrderContext } from 'state/order';
import { routes } from 'utils/routing';

import DesktopHeader from './desktop-header';
import MobileHeader from './mobile-header';

const AppHeader: React.FC = () => {
  const { isAuthenticated } = useAuthContext();
  const { serviceMode, cateringPickupDateTime, deliveryAddress } = useOrderContext();
  const isMobile = useMediaQuery('mobile');
  const { updateAppHeaderDimensions } = useAppHeaderDimensions();

  const {
    location: { pathname },
  } = useLocation();

  if (pathname === routes.cart) {
    return null;
  }

  return (
    <Measure
      onResize={contentRect => {
        if (contentRect.entry) {
          updateAppHeaderDimensions({
            top: contentRect.entry.top,
            left: contentRect.entry.left,
            width: contentRect.entry.width,
            height: contentRect.entry.height,
          });
        }
      }}
    >
      {({ measureRef }) =>
        isMobile ? (
          <MobileHeader
            ref={measureRef}
            isAuthenticated={isAuthenticated}
            serviceMode={serviceMode}
            userAddress={deliveryAddress?.addressLine1}
            cateringPickupDateTime={cateringPickupDateTime}
          />
        ) : (
          <DesktopHeader
            ref={measureRef}
            serviceMode={serviceMode}
            userAddress={deliveryAddress?.addressLine1}
            cateringPickupDateTime={cateringPickupDateTime}
          />
        )
      }
    </Measure>
  );
};

export default AppHeader;
export { default as LogoHeader } from './logo-header';
export { default as MenuHeader, HEADER_HEIGHT } from './menu-header';
